import apiClient from "@/api/client";

export interface KnowledgeDocument {
  id: string;
  filename: string;
  content_type: string;
  file_size: number;
  chunk_count: number;
  status: string;
  created_at: string;
}

export interface KnowledgeListResponse {
  documents: KnowledgeDocument[];
}

export interface KnowledgeSearchHit {
  content?: string;
  text?: string;
  score?: number;
  metadata?: Record<string, unknown>;
}

export interface KnowledgeSearchResponse {
  results: KnowledgeSearchHit[];
}

export interface KnowledgeUploadResponse {
  filename: string;
  content_type: string;
  status: string;
  chunks: number;
  message?: string;
}

export async function listDocuments(): Promise<KnowledgeListResponse> {
  const r = await apiClient.get("/api/v1/knowledge/documents");
  return r.data;
}

export async function searchKnowledge(
  query: string,
  limit = 10,
): Promise<KnowledgeSearchResponse> {
  const r = await apiClient.post("/api/v1/knowledge/search", { query, limit });
  return r.data;
}

export async function uploadDocument(
  file: File,
): Promise<KnowledgeUploadResponse> {
  const form = new FormData();
  form.append("file", file);
  const r = await apiClient.post("/api/v1/knowledge/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
}
